import { EvaluationResultSpecific } from '@agilelab/plugin-wb-governance-common';
import { snakeCaseToTitleCase } from '@agilelab/plugin-wb-platform-common';
import { useMemo } from 'react';

export const useEvaluationResultTitle = (
  result: EvaluationResultSpecific | null | undefined,
) => {
  return useMemo(
    () =>
      result
        ? `${snakeCaseToTitleCase(result.governance_entity_type || '')} ${
            result.governance_entity?.name || result.metric?.name
          } on ${result.resource_display_name}`
        : '',
    [result],
  );
};
